export default {
  data(){
    return {

    }
  },
  computed: {
    sellingPartnersList: function(){
      return Array.from(new Set(this.data.reduce(function(accumulator, item){

        let partners = [];

        if (item.node.metrics && item.node.metrics[0].feeds !== undefined)
        {
          partners = item.node.metrics[0].feeds.map(item => item.feedId);
        }

        return accumulator.concat(partners);
      }, [])));
    },
    isSellingPartnersExists: function(){
      return this.sellingPartnersList.length;
    },
    getSellingPartnersCount: function(){
      return this.sellingPartnersList.length;
    },
    getPartners: function(){
      let partners = {};
      let that = this;

      if (this.sellingPartnersList.length)
      {
        partners = this.sellingPartnersList.reduce(function(acc, item){
          acc[item] = that.getPartnerByPartnerId(item);

          return acc;
        }, {});
      }

      return partners;
    }
  },
  methods: {
    getPartnerByPartnerId(partnerId){
      let partnerData = this.$store.getters.getPartnerByPartnerId(partnerId);

      if (partnerData !== undefined && partnerData !== null)
      {
        return partnerData.company;
      }

      return null;
    },
  }
}


// WEBPACK FOOTER //
// ./src/components/reports/mixins/sellingPartnerMixin.js